/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
import { type ComponentClass, type HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { N300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// 104px from top - (192px header height + 3px border)
export const avatarIntoHeaderImageIntrusion = -91;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SidebarContent = styled.div`
	margin-top: ${avatarIntoHeaderImageIntrusion}px;
`;

// An extra styled component due to the -91 margin. Should be able to delete in the user profile rewrite.
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SidebarContentNext = styled.div`
	margin-top: ${avatarIntoHeaderImageIntrusion}px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SidebarContentBreak = styled.div`
	height: 0;
	padding: 0;
	margin: ${token('space.250', '20px')} 0 0 0;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AvatarWrapper = styled.div`
	position: relative;
	display: inline-block;
	height: 134px;
	width: 134px;
	border-radius: 50%;
	margin-bottom: ${token('space.200', '16px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Details = styled.div`
	display: flex;
	flex-direction: column;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Name = styled.h1`
	font: ${token('font.heading.large')};
	margin-top: 0;
	margin-bottom: ${token('space.150', '12px')};
	word-break: break-all;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Nickname = styled.span`
	color: ${token('color.text.subtlest', N300)};
	margin-bottom: ${token('space.150', '12px')};
	word-break: break-all;
`;

interface LoadingWrapperProps {
	isLoading?: boolean;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingWrapper: ComponentClass<
	HTMLAttributes<{}> & LoadingWrapperProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
> = styled.div`
	opacity: ${(props: LoadingWrapperProps) => (props.isLoading ? 0 : 1)};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NonActiveUserLozenge = styled.div`
	margin-bottom: ${token('space.250', '20px')};
	margin-top: ${token('space.050', '4px')};
`;
